export default __webpack_public_path__ + "static/media/brand-primary.d333ddb7.svg";